import http from "infra/http";
import { useMutation } from "react-query";

function useToggleFornecedorStatus() {
  return useMutation(
    "/v1/fornecedor/mudar-status",
    async (params: { id: string; nextStatus: boolean }) =>
      http.put(
        `/v1/fornecedor/${params.id}/${
          params.nextStatus ? "ativar" : "desativar"
        }`
      )
  );
}

export default useToggleFornecedorStatus;
